import React, { useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../../_metronic/_partials/controls";
import { useOrganizationDeleteDataUIContext } from "./OrganizationDeleteDataUIContext";
import { OrganizationDeleteDataFilter } from "./organization-delete-data-filter/OrganizationDeleteDataFilter";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { Typography } from "@material-ui/core";
import OrganizationDeleteDataModal from "./organization-delete-data-modal/OrganizationDeleteDataModal";
import * as orgDelete from "../../_redux/organization-delete-data/organizationDeleteDataCrud";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";

export const OrganizationDeleteDataCard = () => {
  const [status, setStatus] = useState(0);
  const [modal, setModal] = useState(false);
  const [organization, setOrganization] = useState({});

  const steps = [
    {
      label: "Hapus Semua Data Donasi Payment"
    },
    {
      label: "Hapus Semua Data Donasi Konfirmasi"
    },
    {
      label: "Hapus Semua Data List Import Donasi"
    },
    {
      label: "Hapus Semua Data Import Donasi"
    },
    {
      label: "Hapus Semua Data Donasi Item"
    },
    {
      label: "Hapus Semua Data Donasi Log"
    },
    {
      label: "Hapus Semua Data Donasi"
    },
    {
      label: "Hapus Semua Data Lembaga File"
    },
    {
      label: "Hapus Semua Data Lembaga Report"
    },
    {
      label: "Hapus Semua Data Proyek Program"
    },
    {
      label: "Hapus Semua Data Proyek Income"
    },
    {
      label: "Hapus Semua Data Proyek File"
    },
    {
      label: "Hapus Semua Data Proyek Expense"
    },
    {
      label: "Hapus Semua Data Proyek"
    },
    {
      label: "Hapus Semua Data Program"
    },
    {
      label: "Hapus Semua Data Jenis Dana"
    },
    {
      label: "Hapus Semua Data File"
    },
    {
      label: "Hapus Semua Data EChannel Statement"
    },
    {
      label: "Hapus Semua Data Bank Transfer"
    },
    {
      label: "Hapus Semua Data Bank Statement"
    },
    {
      label: "Hapus Semua Data Bank Import"
    },
    {
      label: "Hapus Semua Data Bank Pooling"
    },
    {
      label: "Hapus Semua Data Payment Method"
    },
    {
      label: "Hapus Semua Data Payment Gateway"
    },
    {
      label: "Hapus Semua Data Rekening Bank"
    },
    {
      label: "Hapus Semua Data Bank"
    },
    {
      label: "Hapus Semua Data Donatur Log"
    },
    {
      label: "Hapus Semua Data Donatur"
    },
    {
      label: "Hapus Semua Data Tipe Donatur"
    },
  ];

  const resetDataOrganization = async (orgId) => {
    try {
      toast.success('Mulai Melakukan Proses..', toastOption);

      let result = await orgDelete.deleteDonationPayment(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }
  
      result = await orgDelete.donationConfirmation(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.donationListImport(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.donationImport(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.donationItem(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.donationLog(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.donation(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.orgFile(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.orgReport(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.projectProgram(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.projectIncome(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.projectFile(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.projectExpense(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.project(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.program(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.fundType(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.file(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.echannelStatement(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.bankTrx(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.bankStatement(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.bankImport(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.bankPooling(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.paymentMethod(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.paymentGateway(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.bankAccount(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.bank(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.donorLog(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.donor(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      result = await orgDelete.donorCategory(orgId);
  
      if (result && result.data.data === '0') {
        setStatus(prev => prev + 1);
      } else {
        return;
      }

      toast.success('Proses Reset Berhasil', toastOption);
    } catch (err) {
      toast.error(err.message, toastOption);
      throw err;
    }
  }

  return (
    <Card>
      <OrganizationDeleteDataModal
        show={modal}
        organization={organization}
        onCancel={() => setModal(false)}
        onAction={() => {
          setModal(false);
          resetDataOrganization(organization?.uuid);
        }}
      />
      <CardHeader title="Hapus Data Lembaga" />
      <CardBody>
        <OrganizationDeleteDataFilter onOpenModal={setModal} onSetOrganization={(v) => setOrganization(v)} />
        <hr />
        <div>
          <h6>Detail Proses</h6>
          <Stepper activeStep={status} orientation="vertical">                  
              {steps.map((item, i) => (
                <Step key={i}>
                  <StepLabel>
                    <Typography>{item.label}</Typography>
                  </StepLabel>
                </Step>
              ))}
          </Stepper>
        </div>
      </CardBody>
    </Card>
  );
};
